import React from "react";
import "styles/modules/footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <p>&#169; Tucandera Tours todos los derechos reservados.</p>
    </footer>
  );
};

export default Footer;
